export default {
  mounted() {
    if (this.$options.pageTitle) {
      document.title = this.$options.pageTitle
    }
  }
}